var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21041 1.11623L11.5016 8.41987C12.1661 8.94267 12.1661 10.1056 11.5016 10.6284L2.21041 17.9321C1.54543 18.4549 0.614718 18.8927 0.0801662 17.9321C-0.356051 16.2476 1.31025 14.219 1.31025 9.25597C1.31025 4.91499 -0.382752 1.947 0.0801662 1.11623C0.357969 0.0405726 1.54543 0.593975 2.21041 1.11623Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.b1a1ee1f53b996f2be0a9fc162735222.svg";
export { ForwardRef as ReactComponent };